<div class="toll-free-notification-modal">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="notification-icon">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </div>
    
    <div class="notification-content">
      <h4 class="notification-title">Important Notice:</h4>
      <p class="notification-message">
        Please note that <strong>1st February 2026</strong> has been declared as a Non-Transaction Day. <br><br> 
        Although the Securities markets will remain open, no purchase, redemption, switch, or SIP transactions will be accepted or processed on this day for all Schemes of ITI Mutual Fund.
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeModal()">
        Got it
      </button>
    </div>
  </div>
</div>
